import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as actionsTypesMembers from '../actionsTypesMembers'

import { fetchResendEmailMembersAction } from './SignUpMembers'

function signInMembersRequest(isLoading) {
  return {
    type: actionsTypesMembers.SIGNIN_MEMBERS_REQUEST,
    isLoading,
  }
}
function signInMembersFailure(isError) {
  return {
    type: actionsTypesMembers.SIGNIN_MEMBERS_FAILURE,
    isError,
  }
}
function signInMembersSuccess(isSuccess, isSuccessNotVerified) {
  return {
    type: actionsTypesMembers.SIGNIN_MEMBERS_SUCCESS,
    isSuccess,
    isSuccessNotVerified,
  }
}
export function fetchSignInMembersAction(userData) {
  return function(dispatch, getState) {

    dispatch(signInMembersRequest(true))

    return backendMembers.login(userData.email, userData.password)
      .then(user => {
        dispatch(signInMembersRequest(false))
        if (!user.isVerified) {
          backendMembers.logout()
          dispatch(signInMembersSuccess(false, true))
        }else {
          dispatch(signInMembersSuccess(true, false))
        }
      })
      .catch(error => {
        dispatch(signInMembersRequest(false))
        dispatch(signInMembersFailure(true))
      })
  }
}

function verifiedEmailMembersRequest(isLoading) {
  return {
    type: actionsTypesMembers.VERIFIED_EMAIL_MEMBERS_REQUEST,
    isLoading,
  }
}
function verifiedEmailMembersFailure(isError) {
  return {
    type: actionsTypesMembers.VERIFIED_EMAIL_MEMBERS_FAILURE,
    isError,
  }
}
function verifiedEmailMembersSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.VERIFIED_EMAIL_MEMBERS_SUCCESS,
    isSuccess,
  }
}
export function fetchVerifiedEmailMembersAction(tokenAccess) {
  return function(dispatch, getState) {

    dispatch(verifiedEmailMembersRequest(true))

    return backendMembers.verifyUser(tokenAccess)
      .then(response => {
        dispatch(verifiedEmailMembersRequest(false))
        dispatch(verifiedEmailMembersSuccess(true))
      })
      .catch(error => {
        dispatch(verifiedEmailMembersRequest(false))
        dispatch(verifiedEmailMembersFailure(true))
      })
  }
}

function tokenExpireMembersRequest(isLoading) {
  return {
    type: actionsTypesMembers.TOKEN_EXPIRE_MEMBERS_REQUEST,
    isLoading,
  }
}
function tokenExpireMembersFailure(isError) {
  return {
    type: actionsTypesMembers.TOKEN_EXPIRE_MEMBERS_FAILURE,
    isError,
  }
}
function tokenExpireMembersSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.TOKEN_EXPIRE_MEMBERS_SUCCESS,
    isSuccess,
  }
}
export function fetchTokenExpireMembersAction(userID) {
  return function(dispatch, getState) {

    dispatch(tokenExpireMembersRequest(true))

    return backendMembers.getUser(userID)
      .then(userData => {
        dispatch(tokenExpireMembersRequest(false))
        dispatch(tokenExpireMembersSuccess(true))
        dispatch(fetchResendEmailMembersAction(userData.email))
      })
      .catch(error => {
        dispatch(tokenExpireMembersRequest(false))
        dispatch(tokenExpireMembersFailure(true))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Authentification/SignInMembers.js